// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-course-report {
    padding-top: 60px;
}
.unit-report {
    width: calc(95vw);
    overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentCourse/Report/Report.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".student-course-report {\n    padding-top: 60px;\n}\n.unit-report {\n    width: calc(95vw);\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
